import React, { useRef } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { useReactToPrint } from "react-to-print";
import DishRecipePrintLayout from "./DishRecipePrintLayout";
import { PiPrinterLight } from "react-icons/pi";
import { useTranslation } from "../../hooks/useTranslation";

const Wrapper = styled.div`
  position: absolute;
  left: -9999px;
  top: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  @media print {
    position: static;
    left: auto;
    top: auto;
    width: auto;
    height: auto;
    overflow: visible;
  }
`;

const PageSettings = createGlobalStyle`
  @media print {
    @page {
      margin: 20mm 15mm;
    }
  }
`;

const DishRecipeFileToPrint = ({ dish }) => {
  const componentRef = useRef(null);
  const { t } = useTranslation();
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: dish?.name ? `${dish.name} - ${t('Recept')}` : t('Recept'),
  });

  if (!dish) {
    return null;
  }

  return (
    <>
      <PageSettings />
      <div className="flex flex-col items-center">
        <Wrapper>
          <DishRecipePrintLayout ref={componentRef} dish={dish} />
        </Wrapper>
        <button
          type="button"
          onClick={handlePrint}
          className="flex justify-center border border-gray-200 rounded px-3 gap-2 cursor-pointer hover:bg-gray-50 py-2"
        >
          <span className="flex items-center justify-center">
            <PiPrinterLight className="w-5 h-5" />
          </span>
          <p className="text-sm text-gray-600">{t('Recept')}</p>
        </button>
      </div>
    </>
  );
};

export default DishRecipeFileToPrint;

